export default __webpack_public_path__ + "static/media/team1.144db6d5.png";